/**
 * Map
 */

import $ from 'jquery';
import Page from 'js/lib/page';

export default class Map extends Page {
  init() {
    this.param = {};

    $.getScript('//api-maps.yandex.ru/2.1/?lang=ru_RU', () => {
      this.setParams();
      this.events();
    });
  }
  setParams() {
    const data = this.$.root.data('init');

    this.markers = data.markers;
    this.param.center = data.center;
    this.param.zoom = data.zoom;
  }
  events() {
    ymaps.ready(() => this.initMap());
  }
  initMap() {
    this.map = new ymaps.Map(
      'map',
      {
        center: this.param.center,
        zoom: this.param.zoom,
        controls: []
      },
      {
        searchControlProvider: false
      }
    );

    var zoomControl = new ymaps.control.ZoomControl({
      options: {
        size: 'small',
        position: {
          left: 'auto',
          right: 20,
          top: this.$.root.height() / 2
        }
      }
    });

    this.map.controls.add(zoomControl);
    this.map.behaviors.disable('scrollZoom');

    this.generateMarkers();
  }
  generateMarkers() {
    this.markers.forEach(marker => {
      this.setMarker(marker.title, marker.coords, marker.image, marker);
    });
  }
  setMarker(title, coords, icon, data) {
    const marker = new ymaps.Placemark(
      coords,
      {
        hintContent: 'Адрес',
        balloonContent: title
      },
      {
        iconImageHref: icon,
        iconLayout: 'default#image',
        iconImageSize: [50, 72],
        iconImageOffset: [-25, -72]
      }
    );

    this.map.geoObjects.add(marker);
  }
}

Page.make(Map, '.js-map');
